export default "__VITE_PUBLIC_ASSET__d7aed87e__"